export default "__VITE_ASSET__C5Ofm7Kg__"